import {
  apiRequest,
  dokumenPensiunDetail,
  dokumenPensiunUpdate,
  dokumenPensiunListPension,
  dokumenPensiunListStop,
} from "../../../../../services/adapters/master/dokumenPensiunService";

class UpdateRepository {
  fetchDetail = async (query) => {
    return await apiRequest(
      "get",
      dokumenPensiunDetail,
      {
        params: query,
      },
      true
    );
  };

  fetchUpdate = async (query) => {
    return await apiRequest(
      "post",
      dokumenPensiunUpdate,
      {
        body: query,
      },
      true
    );
  };
  fetchTypePension = async (query) => {
    return await apiRequest(
      "get",
      dokumenPensiunListPension,
      {
        params: query,
      },
      true
    );
  };

  fetchTypeStop = async (query) => {
    return await apiRequest(
      "get",
      dokumenPensiunListStop,
      {
        params: query,
      },
      true
    );
  };
}

export default UpdateRepository;
